export const getNonEmptyValues = (
  values: Record<string, unknown> | null | undefined,
): Record<string, string | number> => {
  if (!values || typeof values !== 'object') return {}; // Ensure values is a valid object

  return Object.fromEntries(
    Object.entries(values)
      .filter(([key, value]) => {
        if (key === 'test') return false; // Remove "test" key
        if (typeof value === 'string' || typeof value === 'number') {
          return value !== ''; // Keep non-empty strings/numbers
        }
        return false; // Exclude nested objects or invalid types
      })
      .map(([key, value]) => [key, value as string | number]),
  );
};

export const buildFrom = (filters: { name: string }[]) =>
  filters.reduce<Record<string, string | number>>((acc, { name }) => {
    acc[name] = '';
    return acc;
  }, {});
